import crudHandlers from './_crud'

const initialState = {
	personal: [],
	personalById: null,
}
export default (state = initialState, action) => {
	const { type, payload } = action
	switch (type) {
		case 'LOAD_PERSONAL':
			return { ...state, personal: payload }
		case 'LOAD_PERSONAL_BY_ID':
			return { ...state, personalById: payload }
            
		default:
			// state = crudHandlers(state, action, 'personals')

			return state
	}
}
